var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16586_26548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.000976562H0V16.001H16V0.000976562Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16586_26548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64298 2.31062C6.2681 1.6855 7.11593 1.33431 8 1.33431C8.88407 1.33431 9.73193 1.6855 10.357 2.31062C10.9821 2.93574 11.3333 3.78359 11.3333 4.66764V6.66767H4.66667V4.66764C4.66667 3.78359 5.01785 2.93574 5.64298 2.31062ZM12.6667 4.66764V6.66767H13.3333C13.7015 6.66767 14 6.96613 14 7.33433V15.3343C14 15.7025 13.7015 16.001 13.3333 16.001H2.66667C2.29848 16.001 2 15.7025 2 15.3343V7.33433C2 6.96613 2.29848 6.66767 2.66667 6.66767H3.33333V4.66764C3.33333 3.42997 3.825 2.24298 4.70017 1.36781C5.57534 0.492642 6.76233 0.000976562 8 0.000976562C9.23767 0.000976562 10.4247 0.492642 11.2998 1.36781C12.175 2.24298 12.6667 3.42997 12.6667 4.66764ZM3.33333 14.6677V8.001H12.6667V14.6677H3.33333ZM7.0572 12.2771C6.80713 12.0271 6.66667 11.6879 6.66667 11.3343C6.66667 10.9807 6.80713 10.6415 7.0572 10.3915C7.30727 10.1415 7.6464 10.001 8 10.001C8.3536 10.001 8.69273 10.1415 8.9428 10.3915C9.19287 10.6415 9.33333 10.9807 9.33333 11.3343C9.33333 11.6879 9.19287 12.0271 8.9428 12.2771C8.69273 12.5272 8.3536 12.6677 8 12.6677C7.6464 12.6677 7.30727 12.5272 7.0572 12.2771Z",
    fill: "#D1D1D1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ecbf51299aa745971c4d47b2f564ae56.svg";
export { ForwardRef as ReactComponent };